import { ServiceBase } from "./service.base";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, BehaviorSubject, of } from "rxjs";
import { range } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable()
export class ProcessoCasoAtendimentoDetalhesService extends ServiceBase {
        
    constructor(private http: HttpClient) {
        super();
    }

    public endpoint = 'ProcessoCasoAtendimentoDetalhes/';
    private dataSource = new BehaviorSubject<any>([]);
    currenteData = this.dataSource.asObservable();

    changeData(data: any[]) {
        this.dataSource.next(data);
    }

    getAllByRegistro(tipo: string, registroId: string): Observable<any> {
        return this.http.get(environment.api + this.endpoint + `${tipo}/${registroId}`)
            .pipe(
                map(this.extractData),
                catchError(this.serviceError)
            );
    }

    getAll(): Observable<any> {
        return this.http.get(environment.api + this.endpoint)
            .pipe(
                map(this.extractData),
                catchError(this.serviceError)
            );
    }
}
